import React from "react"
import "./spinner.scss"

const Spinner = ({ dark = false}) => {
  return <div className={`loader ${dark ? 'dark': ''}`}></div>
}
export default Spinner
